import React from 'react';
import cartesBancaires from 'assets/images/cartes-bancaires.svg';
import { SvgIconProps } from '@mui/material';

export const AfCartesBancairesIcon: React.FC<SvgIconProps> = () => {
  return <img src={cartesBancaires} />;
};
